import { RequestService } from '../../../../../common/services/RequestService';
import { INTERIORS_GET } from '../../constants';

export const getInteriorsRequest = payload => {
  return RequestService.get(INTERIORS_GET);
};
